export const verbData = [
  { id: 1, korean: "수행하다", english: "perform" },
  { id: 2, korean: "위치하다", english: "position" },
  { id: 3, korean: "시장에 내놓다", english: "market" },
  { id: 4, korean: "처리하다", english: "process" },
  { id: 5, korean: "접근하다", english: "access" },
  { id: 6, korean: "수준을 맞추다", english: "level" },
  { id: 7, korean: "보다, 바라보다", english: "view" },
  { id: 8, korean: "표시하다, 채점하다", english: "mark" },
  { id: 9, korean: "소리내다", english: "sound" },
  { id: 10, korean: "이름짓다, 명명하다", english: "name" },
  { id: 11, korean: "주장하다", english: "claim" },
  { id: 12, korean: "결과가 나오다", english: "result" },
  { id: 13, korean: "끝내다", english: "end" },
  { id: 14, korean: "보고하다", english: "report" },
  { id: 15, korean: "다루다, 처리하다", english: "handle" },
  { id: 16, korean: "혜택을 주다", english: "benefit" },
  { id: 17, korean: "목록을 작성하다", english: "list" },
  { id: 35, korean: "요금을 부과하다, 충전하다", english: "charge" },
  { id: 36, korean: "손상시키다", english: "damage" },
  { id: 37, korean: "지연시키다", english: "delay" },
  { id: 38, korean: "전달하다, 발표하다", english: "deliver" },
  { id: 39, korean: "전시하다, 보여주다", english: "display" },
  { id: 40, korean: "고용하다, 활용하다", english: "employ" },
  { id: 41, korean: "추정하다, 견적을 내다", english: "estimate" },
  { id: 42, korean: "경험하다", english: "experience" },
  { id: 43, korean: "서류를 정리하다, 제출하다", english: "file" },
  { id: 44, korean: "형성하다, 구성하다", english: "form" },
  { id: 45, korean: "집중하다", english: "focus" },
  { id: 46, korean: "주최하다", english: "host" },
  { id: 47, korean: "보관하다, 기록 보존하다", english: "archive" },
  { id: 48, korean: "통제하다, 제어하다", english: "control" },
  { id: 49, korean: "거절하다, 감소하다", english: "decline" },
  { id: 50, korean: "예치하다, 입금하다", english: "deposit" },
  { id: 51, korean: "특징으로 삼다, 등장시키다", english: "feature" },
  { id: 52, korean: "자금을 조달하다", english: "finance" },
  { id: 53, korean: "보증하다", english: "guarantee" },
  { id: 54, korean: "강조하다", english: "highlight" },
  { id: 55, korean: "영향을 미치다", english: "impact" },
  { id: 56, korean: "검사하다", english: "inspect" },
  { id: 57, korean: "출시하다, 발사하다", english: "launch" },
  { id: 58, korean: "적재하다, 불러오다", english: "load" },
  { id: 59, korean: "일치시키다, 맞추다", english: "match" },
  { id: 60, korean: "주목하다, 메모하다", english: "note" },
  { id: 61, korean: "알아차리다, 통지하다", english: "notice" },
  { id: 62, korean: "언급하다", english: "mention" },
  { id: 63, korean: "제안하다", english: "offer" },
  { id: 64, korean: "발표하다, 제시하다", english: "present" },
  { id: 65, korean: "진행하다, 발전하다", english: "progress" },
  { id: 66, korean: "생산하다", english: "produce" },
  { id: 67, korean: "홍보하다, 승진시키다", english: "promote" },
  { id: 68, korean: "증명하다", english: "prove" },
  { id: 69, korean: "평가하다, 등급을 매기다", english: "rate" },
  { id: 70, korean: "올리다, 모금하다", english: "raise" },
  { id: 71, korean: "기록하다", english: "record" },
  { id: 72, korean: "일정을 잡다", english: "schedule" },
  { id: 73, korean: "확보하다, 보안을 유지하다", english: "secure" },
  { id: 74, korean: "서비스하다, 정비하다", english: "service" },
  { id: 75, korean: "이전하다, 전송하다", english: "transfer" },
  { id: 76, korean: "업데이트하다, 갱신하다", english: "update" },
  { id: 77, korean: "가치를 매기다, 소중히 여기다", english: "value" },
  { id: 78, korean: "설명하다, 계좌를 개설하다", english: "account" },
  { id: 79, korean: "정리하다, 치우다", english: "clear" },
  { id: 80, korean: "지시하다, 감독하다", english: "direct" },
  { id: 81, korean: "요구하다, 수요가 있다", english: "demand" },
  { id: 82, korean: "알아내다, 계산하다", english: "figure" },
  { id: 83, korean: "전시하다, 보여주다", english: "exhibit" },
  { id: 84, korean: "발행하다, 문제를 제기하다", english: "issue" },
  { id: 85, korean: "도달하다, 연락하다", english: "reach" },
  { id: 86, korean: "출시하다, 방출하다", english: "release" },
  { id: 87, korean: "분류하다, 정렬하다", english: "sort" },
];
